const renderError = (form, model, attr, error) => {
  const input = form.querySelector(`#${model}_${attr}`)

  if (input) {
    input.classList.add("border-red-500")
    input.insertAdjacentHTML("afterend", errorElement(error))
  }
}

const errorElement = (message) => {
  return `<p class="error-messages mt-1 text-red-500 text-xs">${message}</p>`
}

const reset = () => {
  document.querySelectorAll(".error-messages").forEach((el) => el.remove())
  document.querySelectorAll(".border-red-500")
          .forEach((el) => el.classList.remove("border-red-500"))
}

document.addEventListener("ajax:error", (event) => {
  reset()
  const form = document.querySelector("[data-error='form']")
  const [data] = event.detail
  const model = data.model
  const errors = data.errors

  if (model && errors) {
    Object.entries(errors).forEach(([key, value]) => {
      renderError(form, model, key, value[0])
    })
  }
})
